import { FaFacebook, FaInstagram, FaLinkedin } from "react-icons/fa";
import Typewriter from "typewriter-effect";

const HomeBanner = ({ langWords }) => {
	return (
		<div>
			<header
				className="relative"
				style={{
					backgroundImage: "url('./assets/bg.jpg')",
					backgroundPosition: "center",
					backgroundRepeat: "no-repeat",
					backgroundAttachment: "fixed",
					backgroundSize: "cover",
					minHeight: "600px",
					marginTop: "70px",
				}}
			>
				<div className="absolute top-0 left-0 h-full w-full bg-primary bg-opacity-70 p-4">
					<h1 className="text-secondary font-semibold text-2xl sm:text-4xl md:text-5xl lg:text-6xl text-center pt-20">
						<img
							src="./assets/logo-light.png"
							alt="adsil"
							className="w-64 mx-auto mb-12 block"
						/>
						<Typewriter
							options={{
								strings: langWords?.bannerText,
								autoStart: true,
							}}
						/>
					</h1>
					<div className="flex items-stretch justify-center space-x-2 mt-8">
						<button className="flex w-36 items-center justify-center hover:bg-opacity-80 hover:text-secondary cursor-pointer">
							<img src="/assets/icons/apple-store.svg" alt="googlePlay" />
						</button>
						<button className="flex w-36 items-center justify-center hover:bg-opacity-80 cursor-pointer">
							<img src="/assets/icons/google-play.svg" alt="googlePlay" />
						</button>
					</div>
					<div className="container mt-20 sm:mt-8">
						<ul className="flex sm:block items-center justify-center border-t-4 sm:border-t-0 py-2 sm:py-0 space-x-2 sm:space-x-0 sm:border-l-4 sm:px-2 sm:space-y-3 text-secondary">
							<li>
								<a
									className="flex items-center space-x-2 group w-min"
									href="/"
									target="_blank"
									rel="noreferrer noopener"
								>
									<FaFacebook className="group-hover:text-third" />
									<span>facebook</span>
								</a>
							</li>
							<li>
								<a
									className="flex items-center space-x-2  group w-min"
									href="/"
									target="_blank"
									rel="noreferrer noopener"
								>
									<FaInstagram className="group-hover:text-third" />
									<span>instagram</span>
								</a>
							</li>
							<li>
								<a
									className="flex items-center space-x-2  group w-min"
									href="/"
									target="_blank"
									rel="noreferrer noopener"
								>
									<FaLinkedin className="group-hover:text-third" />
									<span>linkedin</span>
								</a>
							</li>
						</ul>
					</div>
				</div>
			</header>
		</div>
	);
};

export default HomeBanner;
